import _newArrowCheck from '@babel/runtime/helpers/newArrowCheck';
import 'core-js/modules/es.function.bind.js';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/es.symbol.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.object.get-own-property-descriptor.js';
import 'core-js/modules/es.array.push.js';
import 'core-js/modules/es.array.for-each.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import 'core-js/modules/es.object.get-own-property-descriptors.js';
import 'core-js/modules/es.object.define-properties.js';
import 'core-js/modules/es.object.define-property.js';
import 'core-js/modules/es.function.name.js';
import { replace, remove as remove$1, append } from '@jumpn/utils-array';
import 'core-js/modules/es.array.find-index.js';
import { hasIn, map } from '@jumpn/utils-composite';
import 'core-js/modules/es.error.cause.js';
import 'core-js/modules/es.error.to-string.js';
import { requestToCompat, errorsToString, getOperationType } from '@jumpn/utils-graphql';
import 'core-js/modules/es.array.find.js';
import 'phoenix';
import 'core-js/modules/es.array.join.js';
import Observable from 'zen-observable';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.array.index-of.js';

var _excluded$3 = ["activeObservers", "canceledObservers"];
var _this$y = undefined;
function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var cancel$1 = function cancel(_ref) {
  _newArrowCheck(this, _this$y);
  var activeObservers = _ref.activeObservers,
    canceledObservers = _ref.canceledObservers,
    rest = _objectWithoutProperties(_ref, _excluded$3);
  return _objectSpread$9(_objectSpread$9({}, rest), {}, {
    isActive: false,
    activeObservers: [],
    canceledObservers: [].concat(_toConsumableArray(activeObservers), _toConsumableArray(canceledObservers))
  });
}.bind(undefined);

var _this$x = undefined;
var getNotifier = function getNotifier(handlerName, payload) {
  var _this2 = this;
  _newArrowCheck(this, _this$x);
  return function (observer) {
    _newArrowCheck(this, _this2);
    return observer[handlerName] && observer[handlerName](payload);
  }.bind(this);
}.bind(undefined);
var getHandlerName = function getHandlerName(_ref) {
  _newArrowCheck(this, _this$x);
  var name = _ref.name;
  return "on".concat(name);
}.bind(undefined);
var notifyAll = function notifyAll(observers, event) {
  _newArrowCheck(this, _this$x);
  return observers.forEach(getNotifier(getHandlerName(event), event.payload));
}.bind(undefined);

var _this$w = undefined;
var notifyCanceled = function notifyCanceled(notifier, event) {
  _newArrowCheck(this, _this$w);
  notifyAll(notifier.canceledObservers, event);
  return notifier;
}.bind(undefined);

var eventNames = {
  abort: "Abort",
  cancel: "Cancel",
  error: "Error",
  result: "Result",
  start: "Start"
};

var _this$v = undefined;
var createStartEvent = function createStartEvent(payload) {
  _newArrowCheck(this, _this$v);
  return {
    payload: payload,
    name: eventNames.start
  };
}.bind(undefined);
var createResultEvent = function createResultEvent(payload) {
  _newArrowCheck(this, _this$v);
  return {
    payload: payload,
    name: eventNames.result
  };
}.bind(undefined);
var createErrorEvent = function createErrorEvent(payload) {
  _newArrowCheck(this, _this$v);
  return {
    payload: payload,
    name: eventNames.error
  };
}.bind(undefined);
var createCancelEvent = function createCancelEvent() {
  _newArrowCheck(this, _this$v);
  return {
    name: eventNames.cancel,
    payload: undefined
  };
}.bind(undefined);
var createAbortEvent = function createAbortEvent(payload) {
  _newArrowCheck(this, _this$v);
  return {
    payload: payload,
    name: eventNames.abort
  };
}.bind(undefined);

var _this$u = undefined;
function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var clearCanceled = function clearCanceled(notifier) {
  _newArrowCheck(this, _this$u);
  return _objectSpread$8(_objectSpread$8({}, notifier), {}, {
    canceledObservers: []
  });
}.bind(undefined);
var flushCanceled = function flushCanceled(notifier) {
  _newArrowCheck(this, _this$u);
  return notifier.canceledObservers.length > 0 ? clearCanceled(notifyCanceled(notifier, createCancelEvent())) : notifier;
}.bind(undefined);

var _this$t = undefined;
var findIndex = function findIndex(notifiers, key, value) {
  _newArrowCheck(this, _this$t);
  return (
    // $FlowFixMe: flow is having some troubles to match hasIn signature (curry)
    notifiers.findIndex(hasIn([key], value))
  );
}.bind(undefined);

var _this$s = undefined;
var refresh = function refresh(notifier) {
  var _this2 = this;
  _newArrowCheck(this, _this$s);
  return function (notifiers) {
    _newArrowCheck(this, _this2);
    return replace(findIndex(notifiers, "request", notifier.request), [notifier], notifiers);
  }.bind(this);
}.bind(undefined);

var _this$r = undefined;
var remove = function remove(notifier) {
  var _this2 = this;
  _newArrowCheck(this, _this$r);
  return function (notifiers) {
    _newArrowCheck(this, _this2);
    return remove$1(findIndex(notifiers, "request", notifier.request), 1, notifiers);
  }.bind(this);
}.bind(undefined);

var _this$q = undefined;
var updateNotifiers = function updateNotifiers(absintheSocket, updater) {
  _newArrowCheck(this, _this$q);
  absintheSocket.notifiers = updater(absintheSocket.notifiers);
  return absintheSocket;
}.bind(undefined);

var _this$p = undefined;
var refreshNotifier = function refreshNotifier(absintheSocket, notifier) {
  _newArrowCheck(this, _this$p);
  updateNotifiers(absintheSocket, refresh(notifier));
  return notifier;
}.bind(undefined);

var requestStatuses = {
  canceled: "canceled",
  canceling: "canceling",
  pending: "pending",
  sent: "sent",
  sending: "sending"
};

var _this$o = undefined;
var getObservers = function getObservers(_ref) {
  _newArrowCheck(this, _this$o);
  var activeObservers = _ref.activeObservers,
    canceledObservers = _ref.canceledObservers;
  return [].concat(_toConsumableArray(activeObservers), _toConsumableArray(canceledObservers));
}.bind(undefined);
var notify = function notify(notifier, event) {
  _newArrowCheck(this, _this$o);
  notifyAll(getObservers(notifier), event);
  return notifier;
}.bind(undefined);

var _this$n = undefined;
var abortNotifier = function abortNotifier(absintheSocket, notifier, error) {
  _newArrowCheck(this, _this$n);
  return updateNotifiers(absintheSocket, remove(notify(notifier, createAbortEvent(error))));
}.bind(undefined);

var _this$m = undefined;
var find = function find(notifiers, key, value) {
  _newArrowCheck(this, _this$m);
  return (
    // $FlowFixMe: flow is having some troubles to match hasIn signature (curry)
    notifiers.find(hasIn([key], value))
  );
}.bind(undefined);

var _this$l = undefined;
var notifyActive = function notifyActive(notifier, event) {
  _newArrowCheck(this, _this$l);
  notifyAll(notifier.activeObservers, event);
  return notifier;
}.bind(undefined);

var _this$k = undefined;
var notifyResultEvent = function notifyResultEvent(notifier, result) {
  _newArrowCheck(this, _this$k);
  return notifyActive(notifier, createResultEvent(result));
}.bind(undefined);

var _this$j = undefined;
var notifyStartEvent = function notifyStartEvent(notifier) {
  _newArrowCheck(this, _this$j);
  return notifyActive(notifier, createStartEvent(notifier));
}.bind(undefined);

var _this$i = undefined;
function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var reset = function reset(notifier) {
  _newArrowCheck(this, _this$i);
  return flushCanceled(_objectSpread$7(_objectSpread$7({}, notifier), {}, {
    isActive: true,
    requestStatus: requestStatuses.pending,
    subscriptionId: undefined
  }));
}.bind(undefined);

var _this$h = undefined;
var handlePush = function handlePush(push, handler) {
  _newArrowCheck(this, _this$h);
  return push.receive("ok", handler.onSucceed).receive("error", handler.onError).receive("timeout", handler.onTimeout);
}.bind(undefined);

var _this$g = undefined;
var getPushHandlerMethodGetter = function getPushHandlerMethodGetter(absintheSocket, request) {
  var _this2 = this;
  _newArrowCheck(this, _this$g);
  return function (handle) {
    _newArrowCheck(this, _this2);
    return function () {
      var notifier = find(absintheSocket.notifiers, "request", request);
      if (notifier) {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        handle.apply(void 0, [absintheSocket, notifier].concat(args));
      }
    };
  }.bind(this);
}.bind(undefined);
var getPushHandler = function getPushHandler(absintheSocket, request, notifierPushHandler) {
  _newArrowCheck(this, _this$g);
  return map(getPushHandlerMethodGetter(absintheSocket, request), notifierPushHandler);
}.bind(undefined);
var pushAbsintheEvent = function pushAbsintheEvent(absintheSocket, request, notifierPushHandler, absintheEvent) {
  _newArrowCheck(this, _this$g);
  handlePush(absintheSocket.channel.push(absintheEvent.name, absintheEvent.payload), getPushHandler(absintheSocket, request, notifierPushHandler));
  return absintheSocket;
}.bind(undefined);

var absintheEventNames = {
  doc: "doc",
  unsubscribe: "unsubscribe"
};

var _this$f = undefined;
var createAbsintheUnsubscribeEvent = function createAbsintheUnsubscribeEvent(payload) {
  _newArrowCheck(this, _this$f);
  return {
    payload: payload,
    name: absintheEventNames.unsubscribe
  };
}.bind(undefined);
var createAbsintheDocEvent = function createAbsintheDocEvent(payload) {
  _newArrowCheck(this, _this$f);
  return {
    payload: payload,
    name: absintheEventNames.doc
  };
}.bind(undefined);

var _this$e = undefined;
function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var pushAbsintheDocEvent = function pushAbsintheDocEvent(absintheSocket, _ref, notifierPushHandler) {
  _newArrowCheck(this, _this$e);
  var request = _ref.request;
  return pushAbsintheEvent(absintheSocket, request, notifierPushHandler, createAbsintheDocEvent(requestToCompat(request)));
}.bind(undefined);
var setNotifierRequestStatusSending = function setNotifierRequestStatusSending(absintheSocket, notifier) {
  _newArrowCheck(this, _this$e);
  return refreshNotifier(absintheSocket, _objectSpread$6(_objectSpread$6({}, notifier), {}, {
    requestStatus: requestStatuses.sending
  }));
}.bind(undefined);
var createRequestError = function createRequestError(message) {
  _newArrowCheck(this, _this$e);
  var error = new Error("request: ".concat(message));
  error.object = message;
  return error;
}.bind(undefined);
var onTimeout = function onTimeout(absintheSocket, notifier) {
  _newArrowCheck(this, _this$e);
  return notifyActive(notifier, createErrorEvent(createRequestError("timeout")));
}.bind(undefined);
var onError = function onError(absintheSocket, notifier, errorMessage) {
  _newArrowCheck(this, _this$e);
  return abortNotifier(absintheSocket, notifier, createRequestError(errorMessage));
}.bind(undefined);
var getNotifierPushHandler = function getNotifierPushHandler(onSucceed) {
  _newArrowCheck(this, _this$e);
  return {
    onError: onError,
    onSucceed: onSucceed,
    onTimeout: onTimeout
  };
}.bind(undefined);
var pushRequestUsing = function pushRequestUsing(absintheSocket, notifier, onSucceed) {
  _newArrowCheck(this, _this$e);
  return pushAbsintheDocEvent(absintheSocket, setNotifierRequestStatusSending(absintheSocket, notifier), getNotifierPushHandler(onSucceed));
}.bind(undefined);

var _this$d = undefined;
function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

// TODO: improve this type

var onUnsubscribeSucceedCanceled = function onUnsubscribeSucceedCanceled(absintheSocket, notifier) {
  _newArrowCheck(this, _this$d);
  return updateNotifiers(absintheSocket, remove(flushCanceled(notifier)));
}.bind(undefined);
var onUnsubscribeSucceedActive = function onUnsubscribeSucceedActive(absintheSocket, notifier) {
  _newArrowCheck(this, _this$d);
  return subscribe(absintheSocket, refreshNotifier(absintheSocket, reset(notifier)));
}.bind(undefined);
var createUnsubscribeError = function createUnsubscribeError(message) {
  _newArrowCheck(this, _this$d);
  return new Error("unsubscribe: ".concat(message));
}.bind(undefined);
var unsubscribeHandler = {
  onError: function onError(absintheSocket, notifier, errorMessage) {
    _newArrowCheck(this, _this$d);
    return abortNotifier(absintheSocket, notifier, createUnsubscribeError(errorMessage));
  }.bind(undefined),
  onTimeout: function onTimeout(absintheSocket, notifier) {
    _newArrowCheck(this, _this$d);
    return notifyCanceled(notifier, createErrorEvent(createUnsubscribeError("timeout")));
  }.bind(undefined),
  onSucceed: function onSucceed(absintheSocket, notifier) {
    _newArrowCheck(this, _this$d);
    if (notifier.isActive) {
      onUnsubscribeSucceedActive(absintheSocket, notifier);
    } else {
      onUnsubscribeSucceedCanceled(absintheSocket, notifier);
    }
  }.bind(undefined)
};
var pushAbsintheUnsubscribeEvent = function pushAbsintheUnsubscribeEvent(absintheSocket, _ref) {
  _newArrowCheck(this, _this$d);
  var request = _ref.request,
    subscriptionId = _ref.subscriptionId;
  return pushAbsintheEvent(absintheSocket, request, unsubscribeHandler, createAbsintheUnsubscribeEvent({
    subscriptionId: subscriptionId
  }));
}.bind(undefined);
var unsubscribe = function unsubscribe(absintheSocket, notifier) {
  _newArrowCheck(this, _this$d);
  return pushAbsintheUnsubscribeEvent(absintheSocket, refreshNotifier(absintheSocket, _objectSpread$5(_objectSpread$5({}, notifier), {}, {
    requestStatus: requestStatuses.canceling
  })));
}.bind(undefined);
var onSubscribeSucceed = function onSubscribeSucceed(absintheSocket, notifier, _ref2) {
  _newArrowCheck(this, _this$d);
  var subscriptionId = _ref2.subscriptionId;
  var subscribedNotifier = refreshNotifier(absintheSocket, _objectSpread$5(_objectSpread$5({}, notifier), {}, {
    subscriptionId: subscriptionId,
    requestStatus: requestStatuses.sent
  }));
  if (subscribedNotifier.isActive) {
    notifyStartEvent(subscribedNotifier);
  } else {
    unsubscribe(absintheSocket, subscribedNotifier);
  }
}.bind(undefined);
var onSubscribe = function onSubscribe(absintheSocket, notifier, response) {
  _newArrowCheck(this, _this$d);
  if (response.errors) {
    onError(absintheSocket, notifier, errorsToString(response.errors));
  } else {
    onSubscribeSucceed(absintheSocket, notifier, response);
  }
}.bind(undefined);
var subscribe = function subscribe(absintheSocket, notifier) {
  _newArrowCheck(this, _this$d);
  return pushRequestUsing(absintheSocket, notifier, onSubscribe);
}.bind(undefined);
var onDataMessage = function onDataMessage(absintheSocket, _ref3) {
  _newArrowCheck(this, _this$d);
  var payload = _ref3.payload;
  var notifier = find(absintheSocket.notifiers, "subscriptionId", payload.subscriptionId);
  if (notifier) {
    notifyResultEvent(notifier, payload.result);
  }
}.bind(undefined);
var dataMessageEventName = "subscription:data";
var isDataMessage = function isDataMessage(message) {
  _newArrowCheck(this, _this$d);
  return message.event === dataMessageEventName;
}.bind(undefined);

var _this$c = undefined;
var cancelQueryOrMutationSending = function cancelQueryOrMutationSending(absintheSocket, notifier) {
  _newArrowCheck(this, _this$c);
  return updateNotifiers(absintheSocket, refresh(flushCanceled(cancel$1(notifier))));
}.bind(undefined);
var cancelQueryOrMutationIfSending = function cancelQueryOrMutationIfSending(absintheSocket, notifier) {
  _newArrowCheck(this, _this$c);
  return notifier.requestStatus === requestStatuses.sending ? cancelQueryOrMutationSending(absintheSocket, notifier) : absintheSocket;
}.bind(undefined);
var cancelPending = function cancelPending(absintheSocket, notifier) {
  _newArrowCheck(this, _this$c);
  return updateNotifiers(absintheSocket, remove(flushCanceled(cancel$1(notifier))));
}.bind(undefined);
var cancelQueryOrMutation = function cancelQueryOrMutation(absintheSocket, notifier) {
  _newArrowCheck(this, _this$c);
  return notifier.requestStatus === requestStatuses.pending ? cancelPending(absintheSocket, notifier) : cancelQueryOrMutationIfSending(absintheSocket, notifier);
}.bind(undefined);
var unsubscribeIfNeeded = function unsubscribeIfNeeded(absintheSocket, notifier) {
  _newArrowCheck(this, _this$c);
  return notifier.requestStatus === requestStatuses.sent ? unsubscribe(absintheSocket, notifier) : absintheSocket;
}.bind(undefined);
var cancelNonPendingSubscription = function cancelNonPendingSubscription(absintheSocket, notifier) {
  _newArrowCheck(this, _this$c);
  return unsubscribeIfNeeded(absintheSocket, refreshNotifier(absintheSocket, cancel$1(notifier)));
}.bind(undefined);
var cancelSubscription = function cancelSubscription(absintheSocket, notifier) {
  _newArrowCheck(this, _this$c);
  return notifier.requestStatus === requestStatuses.pending ? cancelPending(absintheSocket, notifier) : cancelNonPendingSubscription(absintheSocket, notifier);
}.bind(undefined);
var cancelActive = function cancelActive(absintheSocket, notifier) {
  _newArrowCheck(this, _this$c);
  return notifier.operationType === "subscription" ? cancelSubscription(absintheSocket, notifier) : cancelQueryOrMutation(absintheSocket, notifier);
}.bind(undefined);

/**
 * Cancels a notifier sending a Cancel event to all its observers and
 * unsubscribing in case it holds a subscription request
 *
 * @example
 * import * as withAbsintheSocket from "@framasoft/socket";
 *
 * withAbsintheSocket.cancel(absintheSocket, notifier);
 */
var cancel = function cancel(absintheSocket, notifier) {
  _newArrowCheck(this, _this$c);
  return notifier.isActive ? cancelActive(absintheSocket, notifier) : absintheSocket;
}.bind(undefined);

var _this$b = undefined;
function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var setNotifierRequestStatusSent = function setNotifierRequestStatusSent(absintheSocket, notifier) {
  _newArrowCheck(this, _this$b);
  return refreshNotifier(absintheSocket, _objectSpread$4(_objectSpread$4({}, notifier), {}, {
    requestStatus: requestStatuses.sent
  }));
}.bind(undefined);
var onQueryOrMutationSucceed = function onQueryOrMutationSucceed(absintheSocket, notifier, response) {
  _newArrowCheck(this, _this$b);
  return updateNotifiers(absintheSocket, remove(notifyResultEvent(setNotifierRequestStatusSent(absintheSocket, notifier), response)));
}.bind(undefined);
var pushQueryOrMutation = function pushQueryOrMutation(absintheSocket, notifier) {
  _newArrowCheck(this, _this$b);
  return pushRequestUsing(absintheSocket, notifyStartEvent(notifier), onQueryOrMutationSucceed);
}.bind(undefined);
var pushRequest = function pushRequest(absintheSocket, notifier) {
  _newArrowCheck(this, _this$b);
  if (notifier.operationType === "subscription") {
    subscribe(absintheSocket, notifier);
  } else {
    pushQueryOrMutation(absintheSocket, notifier);
  }
}.bind(undefined);

var _this$a = undefined;
var createChannelJoinError = function createChannelJoinError(message) {
  _newArrowCheck(this, _this$a);
  return new Error("channel join: ".concat(message));
}.bind(undefined);
var notifyErrorToAllActive = function notifyErrorToAllActive(absintheSocket, errorMessage) {
  var _this2 = this;
  _newArrowCheck(this, _this$a);
  return absintheSocket.notifiers.forEach(function (notifier) {
    _newArrowCheck(this, _this2);
    return notifyActive(notifier, createErrorEvent(createChannelJoinError(errorMessage)));
  }.bind(this));
}.bind(undefined);

// join Push is reused and so the handler
// https://github.com/phoenixframework/phoenix/blob/master/assets/js/phoenix.js#L356
var createChannelJoinHandler = function createChannelJoinHandler(absintheSocket) {
  var _this3 = this;
  _newArrowCheck(this, _this$a);
  return {
    onError: function onError(errorMessage) {
      _newArrowCheck(this, _this3);
      return notifyErrorToAllActive(absintheSocket, errorMessage);
    }.bind(this),
    onSucceed: function onSucceed() {
      var _this4 = this;
      _newArrowCheck(this, _this3);
      return absintheSocket.notifiers.forEach(function (notifier) {
        _newArrowCheck(this, _this4);
        return pushRequest(absintheSocket, notifier);
      }.bind(this));
    }.bind(this),
    onTimeout: function onTimeout() {
      _newArrowCheck(this, _this3);
      return notifyErrorToAllActive(absintheSocket, "timeout");
    }.bind(this)
  };
}.bind(undefined);
var joinChannel = function joinChannel(absintheSocket) {
  _newArrowCheck(this, _this$a);
  handlePush(absintheSocket.channel.join(), createChannelJoinHandler(absintheSocket));
  absintheSocket.channelJoinCreated = true;
  return absintheSocket;
}.bind(undefined);

var _this$9 = undefined;
var onMessage = function onMessage(absintheSocket) {
  var _this2 = this;
  _newArrowCheck(this, _this$9);
  return function (message) {
    _newArrowCheck(this, _this2);
    if (isDataMessage(message)) {
      onDataMessage(absintheSocket, message);
    }
  }.bind(this);
}.bind(undefined);
var createConnectionCloseError = function createConnectionCloseError() {
  _newArrowCheck(this, _this$9);
  return new Error("connection: close");
}.bind(undefined);
var notifyConnectionCloseError = function notifyConnectionCloseError(notifier) {
  _newArrowCheck(this, _this$9);
  return notify(notifier, createErrorEvent(createConnectionCloseError()));
}.bind(undefined);
var notifierOnConnectionCloseCanceled = function notifierOnConnectionCloseCanceled(absintheSocket, notifier) {
  _newArrowCheck(this, _this$9);
  return updateNotifiers(absintheSocket, remove(notifyConnectionCloseError(notifier)));
}.bind(undefined);
var notifierOnConnectionCloseActive = function notifierOnConnectionCloseActive(absintheSocket, notifier) {
  _newArrowCheck(this, _this$9);
  if (notifier.operationType === "mutation") {
    abortNotifier(absintheSocket, notifier, createConnectionCloseError());
  } else {
    refreshNotifier(absintheSocket, reset(notifyConnectionCloseError(notifier)));
  }
}.bind(undefined);
var notifierOnConnectionClose = function notifierOnConnectionClose(absintheSocket) {
  var _this3 = this;
  _newArrowCheck(this, _this$9);
  return function (notifier) {
    _newArrowCheck(this, _this3);
    if (notifier.isActive) {
      notifierOnConnectionCloseActive(absintheSocket, notifier);
    } else {
      notifierOnConnectionCloseCanceled(absintheSocket, notifier);
    }
  }.bind(this);
}.bind(undefined);
var onConnectionClose = function onConnectionClose(absintheSocket) {
  var _this4 = this;
  _newArrowCheck(this, _this$9);
  return function () {
    _newArrowCheck(this, _this4);
    return absintheSocket.notifiers.forEach(notifierOnConnectionClose(absintheSocket));
  }.bind(this);
}.bind(undefined);
var shouldJoinChannel = function shouldJoinChannel(absintheSocket) {
  _newArrowCheck(this, _this$9);
  return !absintheSocket.channelJoinCreated && absintheSocket.notifiers.length > 0;
}.bind(undefined);
var onConnectionOpen = function onConnectionOpen(absintheSocket) {
  var _this5 = this;
  _newArrowCheck(this, _this$9);
  return function () {
    _newArrowCheck(this, _this5);
    if (shouldJoinChannel(absintheSocket)) {
      joinChannel(absintheSocket);
    }
  }.bind(this);
}.bind(undefined);
var absintheChannelName = "__absinthe__:control";

/**
 * Creates an Absinthe Socket using the given Phoenix Socket instance
 *
 * @example
 * import * as withAbsintheSocket from "@framasoft/socket";
 * import {Socket as PhoenixSocket} from "phoenix";

 * const absintheSocket = withAbsintheSocket.create(
 *   new PhoenixSocket("ws://localhost:4000/socket")
 * );
 */
var create$1 = function create(phoenixSocket) {
  _newArrowCheck(this, _this$9);
  var absintheSocket = {
    phoenixSocket: phoenixSocket,
    channel: phoenixSocket.channel(absintheChannelName),
    channelJoinCreated: false,
    notifiers: []
  };
  phoenixSocket.onOpen(onConnectionOpen(absintheSocket));
  phoenixSocket.onClose(onConnectionClose(absintheSocket));
  phoenixSocket.onMessage(onMessage(absintheSocket));
  return absintheSocket;
}.bind(undefined);

var _excluded$2 = ["activeObservers"];
var _this$8 = undefined;
function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var observe$1 = function observe(_ref, observer) {
  _newArrowCheck(this, _this$8);
  var activeObservers = _ref.activeObservers,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  return _objectSpread$3(_objectSpread$3({}, rest), {}, {
    activeObservers: [].concat(_toConsumableArray(activeObservers), [observer]),
    isActive: true
  });
}.bind(undefined);

var _this$7 = undefined;
/**
 * Observes given notifier using the provided observer
 *
 * @example
 * import * as withAbsintheSocket from "@framasoft/socket"
 *
 * const logEvent = eventName => (...args) => console.log(eventName, ...args);
 *
 * const updatedNotifier = withAbsintheSocket.observe(absintheSocket, notifier, {
 *   onAbort: logEvent("abort"),
 *   onError: logEvent("error"),
 *   onStart: logEvent("open"),
 *   onResult: logEvent("result")
 * });
 */
var observe = function observe(absintheSocket, notifier, observer) {
  _newArrowCheck(this, _this$7);
  return refreshNotifier(absintheSocket, observe$1(notifier, observer));
}.bind(undefined);

var _this$6 = undefined;
var createUsing = function createUsing(request, operationType) {
  _newArrowCheck(this, _this$6);
  return {
    operationType: operationType,
    request: request,
    activeObservers: [],
    canceledObservers: [],
    isActive: true,
    requestStatus: requestStatuses.pending,
    subscriptionId: undefined
  };
}.bind(undefined);
var create = function create(request) {
  _newArrowCheck(this, _this$6);
  return createUsing(request, getOperationType(request.operation));
}.bind(undefined);

var _this$5 = undefined;
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var reactivate = function reactivate(notifier) {
  _newArrowCheck(this, _this$5);
  return notifier.isActive ? notifier : _objectSpread$2(_objectSpread$2({}, notifier), {}, {
    isActive: true
  });
}.bind(undefined);

var _this$4 = undefined;
var connectOrJoinChannel = function connectOrJoinChannel(absintheSocket) {
  _newArrowCheck(this, _this$4);
  if (absintheSocket.phoenixSocket.isConnected()) {
    joinChannel(absintheSocket);
  } else {
    // socket ignores connect calls if a connection has already been created
    absintheSocket.phoenixSocket.connect();
  }
}.bind(undefined);
var sendNew = function sendNew(absintheSocket, request) {
  _newArrowCheck(this, _this$4);
  var notifier = create(request);
  updateNotifiers(absintheSocket, append([notifier]));
  if (absintheSocket.channelJoinCreated) {
    pushRequest(absintheSocket, notifier);
  } else {
    connectOrJoinChannel(absintheSocket);
  }
  return notifier;
}.bind(undefined);
var updateCanceledReactivate = function updateCanceledReactivate(absintheSocket, notifier) {
  _newArrowCheck(this, _this$4);
  return refreshNotifier(absintheSocket, reactivate(notifier));
}.bind(undefined);
var updateCanceled = function updateCanceled(absintheSocket, notifier) {
  _newArrowCheck(this, _this$4);
  return notifier.requestStatus === requestStatuses.sending ? updateCanceledReactivate(absintheSocket, flushCanceled(notifier)) : updateCanceledReactivate(absintheSocket, notifier);
}.bind(undefined);
var updateIfCanceled = function updateIfCanceled(absintheSocket, notifier) {
  _newArrowCheck(this, _this$4);
  return notifier.isActive ? notifier : updateCanceled(absintheSocket, notifier);
}.bind(undefined);
var getExistentIfAny = function getExistentIfAny(absintheSocket, request) {
  _newArrowCheck(this, _this$4);
  var notifier = find(absintheSocket.notifiers, "request", request);
  return notifier && updateIfCanceled(absintheSocket, notifier);
}.bind(undefined);

/**
 * Sends given request and returns an object (notifier) to track its progress
 * (see observe function)
 *
 * @example
 * import * as withAbsintheSocket from "@framasoft/socket";
 *
 * const operation = `
 *   subscription userSubscription($userId: ID!) {
 *     user(userId: $userId) {
 *       id
 *       name
 *     }
 *   }
 * `;
 *
 * // This example uses a subscription, but the functionallity is the same for
 * // all operation types (queries, mutations and subscriptions)
 *
 * const notifier = withAbsintheSocket.send(absintheSocket, {
 *   operation,
 *   variables: {userId: 10}
 * });
 */
var send = function send(absintheSocket, request) {
  _newArrowCheck(this, _this$4);
  return getExistentIfAny(absintheSocket, request) || sendNew(absintheSocket, request);
}.bind(undefined);

var _excluded$1 = ["unsubscribe"];
var _this$3 = undefined;
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// prettier-ignore
var getUnsubscriber = function getUnsubscriber(absintheSocket, _ref, observer, unsubscribe) {
  var _this2 = this;
  _newArrowCheck(this, _this$3);
  var request = _ref.request;
  return function () {
    _newArrowCheck(this, _this2);
    var notifier = find(absintheSocket.notifiers, "request", request);
    unsubscribe(absintheSocket, notifier, notifier ? observer : undefined);
  }.bind(this);
}.bind(undefined);
var onResult = function onResult(_ref2, observableObserver) {
  var _this3 = this;
  _newArrowCheck(this, _this$3);
  var operationType = _ref2.operationType;
  return function (result) {
    _newArrowCheck(this, _this3);
    observableObserver.next(result);
    if (operationType !== "subscription") {
      observableObserver.complete();
    }
  }.bind(this);
}.bind(undefined);
var createObserver = function createObserver(notifier, handlers, observableObserver) {
  _newArrowCheck(this, _this$3);
  return _objectSpread$1(_objectSpread$1({}, handlers), {}, {
    onAbort: observableObserver.error.bind(observableObserver),
    onResult: onResult(notifier, observableObserver)
  });
}.bind(undefined);

/**
 * Creates an Observable that will follow the given notifier
 *
 * @param {AbsintheSocket} absintheSocket
 * @param {Notifier<Result, Variables>} notifier
 * @param {Object} [options]
 * @param {function(error: Error): undefined} [options.onError]
 * @param {function(notifier: Notifier<Result, Variables>): undefined} [options.onStart]
 * @param {function(): undefined} [options.unsubscribe]
 *
 * @return {Observable}
 *
 * @example
 * import * as withAbsintheSocket from "@framasoft/socket";
 *
 * const unobserveOrCancelIfNeeded = (absintheSocket, notifier, observer) => {
 *   if (notifier && observer) {
 *     withAbsintheSocket.unobserveOrCancel(absintheSocket, notifier, observer);
 *   }
 * };
 *
 * const logEvent = eventName => (...args) => console.log(eventName, ...args);
 *
 * const observable = withAbsintheSocket.toObservable(absintheSocket, notifier, {
 *   onError: logEvent("error"),
 *   onStart: logEvent("open"),
 *   unsubscribe: unobserveOrCancelIfNeeded
 * });
 */
var toObservable = function toObservable(absintheSocket, notifier) {
  var _this4 = this;
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    unsubscribe = _ref3.unsubscribe,
    handlers = _objectWithoutProperties(_ref3, _excluded$1);
  return new Observable(function (observableObserver) {
    _newArrowCheck(this, _this4);
    var observer = createObserver(notifier, handlers, observableObserver);
    observe(absintheSocket, notifier, observer);
    return unsubscribe && getUnsubscriber(absintheSocket, notifier, observer, unsubscribe);
  }.bind(this));
};

var _excluded = ["activeObservers"];
var _this$2 = undefined;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var removeObserver = function removeObserver(observers, observer) {
  _newArrowCheck(this, _this$2);
  return remove$1(observers.indexOf(observer), 1, observers);
}.bind(undefined);
var unobserve$1 = function unobserve(_ref, observer) {
  _newArrowCheck(this, _this$2);
  var activeObservers = _ref.activeObservers,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread(_objectSpread({}, rest), {}, {
    activeObservers: removeObserver(activeObservers, observer)
  });
}.bind(undefined);

var _this$1 = undefined;
var ensureHasActiveObserver = function ensureHasActiveObserver(notifier, observer) {
  _newArrowCheck(this, _this$1);
  if (notifier.activeObservers.includes(observer)) return notifier;
  throw new Error("Observer is not attached to notifier");
}.bind(undefined);

/**
 * Detaches observer from notifier
 *
 * @example
 * import * as withAbsintheSocket from "@framasoft/socket";
 *
 * withAbsintheSocket.unobserve(absintheSocket, notifier, observer);
 */
var unobserve = function unobserve(absintheSocket, notifier, observer) {
  _newArrowCheck(this, _this$1);
  return updateNotifiers(absintheSocket, refresh(unobserve$1(ensureHasActiveObserver(notifier, observer), observer)));
}.bind(undefined);

var _this = undefined;
var doUnobserveOrCancel = function doUnobserveOrCancel(absintheSocket, notifier, observer) {
  _newArrowCheck(this, _this);
  return notifier.activeObservers.length === 1 ? cancel(absintheSocket, notifier) : unobserve(absintheSocket, notifier, observer);
}.bind(undefined);

/**
 * Cancels notifier if there are no more observers apart from the one given, or
 * detaches given observer from notifier otherwise
 *
 * @example
 * import * as withAbsintheSocket from "@framasoft/socket";
 *
 * withAbsintheSocket.unobserve(absintheSocket, notifier, observer);
 */
var unobserveOrCancel = function unobserveOrCancel(absintheSocket, notifier, observer) {
  _newArrowCheck(this, _this);
  return notifier.isActive ? doUnobserveOrCancel(absintheSocket, notifier, observer) : absintheSocket;
}.bind(undefined);

export { cancel, create$1 as create, observe, send, toObservable, unobserve, unobserveOrCancel };
//# sourceMappingURL=index.js.map
